module.exports = __webpack_public_path__ + "assets/img/cloud2.64ac6d5d.png";